import React from 'react'
import { StyleSheet } from 'react-native'

import EarningsCardSection from '@zet/common/components/earningsCardSection'
import { Stack } from '@zet/design-system'
import moment from 'moment'

import { IMyTeamsEarningTransaction } from '../../../api/earnings/types'

type Props = {
  data: IMyTeamsEarningTransaction
  screenName: string
  hasInteraction?: boolean
  showAddedBy?: boolean
}

const TeamEarningsCard = ({ data }: Props) => {
  return (
    <>
      <Stack className="border-grays-30 pt-2" style={styles.card}>
        <EarningsCardSection
          amount={data?.amount}
          name={data.customerName}
          partnerName={data?.partnerName}
          transactionDate={
            data?.transactionDate
              ? moment(data.transactionDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : ''
          }
          status={data?.status}
        />
      </Stack>
    </>
  )
}

export default TeamEarningsCard
const styles = StyleSheet.create({
  tagBgColor: {
    backgroundColor: '#F1E8F5',
  },
  card: {
    borderBottomWidth: 4,
  },
})
